import { Validators } from '@angular/forms';

export const invoiceItems = {
  product: [ , Validators.required],
  costCenter: [ , Validators.required],
  amount: ['', Validators.required],
  vat: [0.21, Validators.required],
  totalAmount: [''],
  productCount: [1, Validators.required],
  qty: ['', Validators.required],
  description: ['', Validators.required],
};